import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Silenciar erros de terceiros (Pixel do TikTok / Facebook, extensões, etc.)
// que tentam injetar CSS via insertRule e falham com HierarchyRequestError.
// Esses erros não afetam o funcionamento do site, mas poluem o console
// e disparam o overlay do React em dev.
if (typeof window !== "undefined") {
  const isThirdPartyNoise = (msg) => {
    if (!msg) return false;
    const m = String(msg);
    return (
      m.includes("insertRule") ||
      m.includes("HierarchyRequestError") ||
      m.includes("ResizeObserver loop") ||
      m.includes("Non-Error promise rejection captured")
    );
  };

  window.addEventListener(
    "error",
    (event) => {
      if (isThirdPartyNoise(event.message) || isThirdPartyNoise(event.error?.message)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return false;
      }
    },
    true
  );

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      const reason = event.reason;
      const msg = typeof reason === "string" ? reason : reason?.message;
      if (isThirdPartyNoise(msg)) {
        event.preventDefault();
      }
    },
    true
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
